import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Gift } from "lucide-react";
import { API, inr } from "../lib/api";
import Seo from "../components/Seo";
import ShareBar from "../components/ShareBar";
import { SITE_URL } from "../lib/seo";

export default function ClubRefer() {
  const [d, setD] = useState(null);
  useEffect(() => { API.get("/referral").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="max-w-3xl mx-auto px-4 py-20 text-stone-500">Loading…</div>;
  const link = `${SITE_URL}/signup?ref=${d.code}`;
  const cards = [["Invited", d.referral_count], ["Joined", d.successful_referrals], ["Earned", inr(d.total_earned)], ["Pending", inr(d.pending)]];
  return (
    <div className="bg-[#FAF6F1] min-h-[70vh]" data-testid="club-refer-page">
      <Seo title="Refer Your Girls | Suvikka Club" description="Bring your girls to Suvikka. Share your referral link and earn eligible wallet rewards when they join and shop." canonicalPath="/club/refer" noindex />
      <section className="bg-gradient-to-br from-[#6A1B29] to-[#501325] text-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20 text-center">
          <h1 className="font-display text-4xl sm:text-6xl font-semibold">Bring Your Girls 💗</h1>
          <p className="text-white/90 mt-3 text-lg">Share Suvikka with friends and earn eligible wallet rewards when they join and shop.</p>
        </div>
      </section>
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white border border-stone-200 rounded-2xl p-6">
          <p className="text-xs font-semibold uppercase tracking-wider text-stone-400">Your Referral Code</p>
          <p className="font-display text-3xl font-bold text-[#6A1B29] mt-1" data-testid="referral-code">{d.code}</p>
          <div className="flex items-center gap-2 mt-4 bg-stone-50 border border-stone-200 rounded-lg p-3">
            <span className="text-sm text-stone-600 truncate flex-1" data-testid="referral-link">{link}</span>
            <button onClick={() => { navigator.clipboard.writeText(link); toast.success("Copied 💗"); }} className="text-stone-400 hover:text-[#6A1B29]" data-testid="copy-referral"><Copy className="w-4 h-4" /></button>
          </div>
          <div className="mt-4"><ShareBar url={link} text={`Join me on Suvikka — everything she loves 💗 Use my code ${d.code}`} /></div>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-6">
          {cards.map(([l, v], i) => <div key={i} className="bg-white border border-stone-200 rounded-2xl p-4 text-center" data-testid={`refer-stat-${i}`}><p className="text-[11px] uppercase text-stone-400">{l}</p><p className="font-display text-xl font-bold mt-1">{v}</p></div>)}
        </div>
        {d.referrals?.length > 0 && (
          <div className="bg-white border border-stone-200 rounded-2xl mt-6 divide-y divide-stone-100" data-testid="referral-list">
            {d.referrals.map((r, i) => <div key={i} className="flex justify-between p-4"><span className="text-sm font-medium text-stone-800">{r.name}</span><span className="text-xs text-stone-400">Joined {r.joined}</span></div>)}
          </div>
        )}
        <p className="text-xs text-stone-400 mt-4 flex items-center gap-1.5"><Gift className="w-4 h-4" /> Referral rewards are credited to your wallet on eligible qualifying orders per applicable terms.</p>
      </section>
    </div>
  );
}
